import { getCompanyName } from '@constants/companies';
import useLocale from '@hooks/useLocale';
import { InternalLink } from '@type-declarations/prepr';
import getInternalRoute from '@utils/getInternalRoute';

import Button from './Button';

interface Props {
  name?: string;
  internalLink?: InternalLink;
  externalLink?: string;
}

export default function CompanyButton({
  name,
  internalLink,
  externalLink,
}: Props) {
  const locale = useLocale();

  if (!name) return null;

  const href = internalLink?.page?.[0]
    ? getInternalRoute({
        internalLink,
        locale,
      })
    : externalLink;

  if (!href) return null;

  return (
    <Button
      label={getCompanyName(name)}
      href={href}
      variant="minimal"
      modifier="pill"
      size="sm"
    />
  );
}
